import React from 'react';

export default function Sidebar({ showBiConnector, setShowBiConnector, onLogout }) {
  return (
    <aside
      className="w-60 min-h-screen flex flex-col flex-shrink-0 border-r"
      style={{
        backgroundColor: '#0f1117',
        borderColor: '#1e2130',
      }}
    >
      {/* Logo / App name */}
      <div className="px-5 py-5 border-b" style={{ borderColor: '#1e2130' }}>
        <div className="flex items-center gap-3">
          {/* Icon mark */}
          <div
            className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
            style={{
              background: 'linear-gradient(135deg, #3b82f6 0%, #6366f1 100%)',
            }}
          >
            <svg className="w-4 h-4 text-white" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
              <ellipse cx="12" cy="5" rx="9" ry="3" />
              <path d="M3 5v4c0 1.657 4.03 3 9 3s9-1.343 9-3V5" />
              <path d="M3 9v4c0 1.657 4.03 3 9 3s9-1.343 9-3V9" />
              <path d="M3 13v4c0 1.657 4.03 3 9 3s9-1.343 9-3v-4" />
            </svg>
          </div>
          <div>
            <p className="text-sm font-semibold text-gray-100 leading-none">Prebuilt Queries</p>
            <p className="text-xs mt-1" style={{ color: '#6b7280' }}>Admin Console</p>
          </div>
        </div>
      </div>

      {/* Nav label */}
      <div className="px-4 pt-5 pb-2">
        <p className="text-xs font-semibold uppercase tracking-widest" style={{ color: '#4b5563' }}>
          Management
        </p>
      </div>

      {/* Navigation */}
      <nav className="flex-1 px-3 space-y-0.5">
        <button
          onClick={() => setShowBiConnector(false)}
          className={`flex items-center gap-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 w-full text-left ${
            !showBiConnector ? 'text-blue-400' : 'text-gray-400 hover:text-gray-200'
          }`}
          style={!showBiConnector
            ? { backgroundColor: 'rgba(59,130,246,0.12)', borderLeft: '2px solid #3b82f6', paddingLeft: '10px', paddingRight: '12px' }
            : { borderLeft: '2px solid transparent', paddingLeft: '10px', paddingRight: '12px' }
          }
        >
          <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
            <ellipse cx="12" cy="5" rx="9" ry="3" />
            <path d="M3 5v4c0 1.657 4.03 3 9 3s9-1.343 9-3V5" />
            <path d="M3 9v4c0 1.657 4.03 3 9 3s9-1.343 9-3V9" />
            <path d="M3 13v4c0 1.657 4.03 3 9 3s9-1.343 9-3v-4" />
          </svg>
          Queries
        </button>

        <button
          onClick={() => setShowBiConnector(true)}
          className={`flex items-center gap-3 py-2.5 rounded-lg text-sm font-medium transition-all duration-150 w-full text-left ${
            showBiConnector ? 'text-emerald-400' : 'text-gray-400 hover:text-gray-200'
          }`}
          style={showBiConnector
            ? { backgroundColor: 'rgba(16,185,129,0.1)', borderLeft: '2px solid #10b981', paddingLeft: '10px', paddingRight: '12px' }
            : { borderLeft: '2px solid transparent', paddingLeft: '10px', paddingRight: '12px' }
          }
        >
          <svg className="w-4 h-4 flex-shrink-0" fill="none" stroke="currentColor" strokeWidth={1.8} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M8 9l3 3-3 3m5 0h3M5 20h14a2 2 0 002-2V6a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
          BI Connector View
        </button>

      </nav>

      {/* Footer */}
      <div className="px-5 py-4 border-t space-y-3" style={{ borderColor: '#1e2130' }}>
        <button
          onClick={onLogout}
          className="flex items-center gap-2 text-xs text-gray-500 hover:text-red-400 transition-colors w-full"
        >
          <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a2 2 0 01-2 2H5a2 2 0 01-2-2V7a2 2 0 012-2h6a2 2 0 012 2v1" />
          </svg>
          Sign out
        </button>
        <p className="text-xs" style={{ color: '#374151' }}>v1.0.5</p>
      </div>
    </aside>
  );
}
